import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSLoading } from "namirasoft-site-react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { PaymentProps } from "../PaymentProps";
import { PaymentRoutes } from "../PaymentRoutes";

interface OfferViewPageProps extends NSARouterMakerResult, PaymentProps { }

function OfferViewPage(props: OfferViewPageProps)
{
    let { id } = useParams<{ id: string }>();

    useEffect(() =>
    {
        if (id)
            props.servers.payment.offer.Get(id).then(offer =>
            {
                props.servers.payment.product.Get(offer.product_id).then(product =>
                {
                    props.servers.payment.sales_item.Get(offer.sales_item_id).then(sales_item =>
                    {
                        props.url.redirect(PaymentRoutes.OfferListOne(product.slug, sales_item.slug, offer.id, false, ""), {})
                    });
                });
            });
        // eslint-disable-next-line
    }, [id]);

    return <NSLoading />;
}

export default OfferViewPage;